import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconTag"><Path fillRule="evenodd" clipRule="evenodd" d="M2 3.75C2 2.7835 2.7835 2 3.75 2H11.579C12.0432 2 12.4883 2.18437 12.8165 2.51256L21.5732 11.2693C22.2566 11.9527 22.2566 13.0608 21.5732 13.7442L13.7442 21.5732C13.0608 22.2566 11.9527 22.2566 11.2693 21.5732L2.51256 12.8165C2.18437 12.4883 2 12.0432 2 11.579V3.75ZM7.5 9C8.32843 9 9 8.32843 9 7.5C9 6.67157 8.32843 6 7.5 6C6.67157 6 6 6.67157 6 7.5C6 8.32843 6.67157 9 7.5 9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTag;
